import { Categories } from 'src/Elements/Sidebar'
import { Category, CategoryItem } from 'src/Elements/Sidebar/Categories'
import { Box, List } from '@mui/material'
import React, { useRef, useState } from 'react'
import { makeStyles } from 'tss-react/mui'
import { useHasNewFeature } from 'src/Libs/new-content'

interface StyleProps {
  back?: boolean
}

const useStyles = makeStyles<StyleProps>()((theme, props) => ({
  firstDrawer: {
    position: 'absolute',
    width: theme.shape.sidebar.drawerWidth,
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      width: '100%',
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  translate: {
    transform: `translateX(${props.back === true ? '-' : '+'}${props.back ? theme.shape.sidebar.drawerWidth : 0}px)`,
    transition: '0.3s ease-in-out',
  },
}))

interface Props {
  links: Category[]
  onClose?: () => void
}

/**
 * Sidebar elements/links for mobile views
 */
const SidebarLinks: React.FC<Props> = ({ links, onClose }) => {
  const myRef = useRef<HTMLDivElement>(null)

  const [openSecond] = useState<boolean>(false)
  const [collapsed] = useState<boolean>(false)
  const [, setCurrentLink] = useState<CategoryItem | undefined>()
  const { handleUpdateContentVersion } = useHasNewFeature()

  const { classes, cx } = useStyles({ back: openSecond })

  const handleCategoryListItemClick = (item: CategoryItem, items?: Category[]): void => {
    if (item.hasNewContent && item.elementKeys) handleUpdateContentVersion(item.elementKeys)
    if (items) setCurrentLink(item)
  }

  return (
    <Box className={cx(classes.firstDrawer, openSecond !== undefined ? classes.translate : undefined)} ref={myRef}>
      <List>
        <Categories categories={links} onClose={onClose} handleCategoryListItemClick={handleCategoryListItemClick} collapsed={collapsed} />
      </List>
    </Box>
  )
}

export default SidebarLinks
